import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { VehiclesListComponent } from './demo/components/vehicles/vehicles-list/vehicles-list.component';
import { DriversComponent } from './demo/components/drivers/drivers.component';
import { RegisterVehicleComponent } from './demo/components/vehicles/register-vehicle/register-vehicle.component';
import { authGuard, childAuthGuard } from './auth-guard.guard';
import { QuotationsComponent } from './demo/components/quotations/quotations.component';
import { VehicleDetailComponent } from './demo/components/vehicles/vehicle-detail/vehicle-detail.component';
import { DriverDetailComponent } from './demo/components/drivers/driver-detail/driver-detail.component';
import { AddDriverComponent } from './demo/components/drivers/add-driver/add-driver.component';
import { ViewPortfolioComponent } from './demo/components/portfolio/view-portfolio.component';
import { OrderDetailComponent } from './demo/components/orders/order-detail.component';
import { ListOrdersComponent } from './demo/components/orders/list-orders.component';
import { UpdateDriverComponent } from './demo/components/drivers/update-driver/update-driver.component';
import { InsuranceLimitsPipe } from './demo/pipes/insurance-limits.pipe';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    useHash: false,
};

const routes: Routes = [
    {
        path: 'home', data: { breadcrumb: '' }, component: AppLayoutComponent,
        canActivate: [authGuard],
        canActivateChild: [childAuthGuard],
        children: [
            { path: '', data: { breadcrumb: 'HOME_DRIVERS' }, component: DriversComponent },
            { path: 'cart', data: { breadcrumb: 'HOME_CART' }, loadChildren: () => import('./demo/components/cart/cart.module').then(m => m.CartModule) },
            { path: 'vehicles', data: { breadcrumb: 'HOME_VEHICLES' }, component: VehiclesListComponent },
            { path: 'vehicles/new', data: { breadcrumb: 'HOME_ADD_VEHICLE' }, component: RegisterVehicleComponent },
            { path: 'drivers/update-driver/:id', data: { breadcrumb: 'HOME_UPDATE_DRIVER' }, component: UpdateDriverComponent },
            { path: 'vehicles/:id', data: { breadcrumb: 'HOME_VEHICLE_DETAILS' }, component: VehicleDetailComponent },
            { path: 'drivers', data: { breadcrumb: 'HOME_DRIVERS' }, component: DriversComponent },
            {path: 'profile', data: { breadcrumb: 'HOME / PROFILE / VIEW'}, loadChildren: () =>import('./demo/components/profile/profile.module').then(m =>m.ProfileModule)},
            { path: 'drivers/new', data: { breadcrumb: 'HOME_ADD_DRIVER' }, component: AddDriverComponent },
            { path: 'drivers/:id', data: { breadcrumb: 'HOME_DRIVER_DETAIL' }, component: DriverDetailComponent },
            { path: 'quotations', data: { breadcrumb: 'HOME_QUOTATION' }, component: QuotationsComponent },
            { path: 'portfolio', data: { breadcrumb: 'HOME_PORTFOLIO' }, component: ViewPortfolioComponent },
            { path: 'orders', data: { breadcrumb: 'HOME_ORDERS' }, component: ListOrdersComponent },
            { path: 'orders/:id', data: { breadcrumb: 'HOME_ORDERS' }, component: OrderDetailComponent },
            { path: 'utilities', data: { breadcrumb: 'Utilities' }, loadChildren: () => import('./demo/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
            { path: 'pages', data: { breadcrumb: 'Pages' }, loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) },
            { path: 'profile', data: { breadcrumb: 'User Management' }, loadChildren: () => import('./demo/components/profile/profile.module').then(m => m.ProfileModule) },
            { path: 'documentation', data: { breadcrumb: 'Documentation' }, loadChildren: () => import('./demo/components/documentation/documentation.module').then(m => m.DocumentationModule) },
            { path: 'blocks', data: { breadcrumb: 'Prime Blocks' }, loadChildren: () => import('./demo/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
            { path: 'ecommerce', data: { breadcrumb: 'E-Commerce' }, loadChildren: () => import('./demo/components/ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
        ]
    },

    { path: '', data: { breadcrumb: 'Auth' }, loadChildren: () => import('./demo/components/auth/auth.module').then(m => m.AuthModule) },
    { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
    { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then(m => m.NotfoundModule) },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule,InsuranceLimitsPipe],
    declarations: [InsuranceLimitsPipe],
})
export class AppRoutingModule { }
